import GridyCommon from '@/modules/gridy_common';
import HandlebarsHelpers from '@/modules/handlebars_helpers';
import Local from '@/modules/local';

import { isPresent, selectedLabel } from '@/modules/helper';

export default class Searcher {
  constructor(grid, template, options) {
    this.categorySelect = $('#gridy_where_category');
    this.grid = grid;
    this.options = options;
    this.rakingSorterField = document.querySelector('[data-raking-sorter-field]');
    this.rankingSorter = $('[ranking-sorter]');
    this.searcher = $('[data-searcher]');
    this.switcher = $('[data-switcher]');
    this.template = template;
    this.typeField = document.querySelector('[data-type]');
  }

  bindRankingSorter() {
    var that = this;

    this.#addActiveClass(this.rankingSorter.find('[data-sort="total_of_rating"]'));

    this.rankingSorter.on('click', 'a', function () {
      var optionSelected = $(this);
      var sortField = optionSelected.data('sort');

      that.rakingSorterField.value = sortField;

      that.#activeSwitcherOption(optionSelected, sortField);

      that.grid.gridy('refresh');
    });
  }

  create() {
    this.gridy();
    this.bindRankingSorter();

    new Local({ grid: this.grid }).create();

    HandlebarsHelpers.init();
  }

  gridy() {
    GridyCommon.gridy(this.grid, $.extend({}, this.gridyOptions(), this.options));
  }

  gridyOptions() {
    return {
      buttonMax: document.documentElement.clientWidth >= 667 ? 3 : 1,
      contentClass: 'grid gap-3 md:gap-4 tb:grid-cols-2 lg:grid-cols-3 mt-14 mx-2 md:mx-4 xl:mx-0',
      find: 'name',
      findClass: 'form__input form__input--fluid mt-3',
      rows: 12,
      rowsClass: 'form__input form__input--fluid mt-3',
      rowsOption: false,
      searchButton: true,
      searchClass: 'form__input form__input--fluid mt-3',
      searchElement: '[data-searcher-field]',
      searchFocus: true,
      sortName: 'created_at',
      sortOrder: 'desc',
      statusOption: false,
      style: 'div',
      template: this.template,

      before: (search, _page, _sortName, _sortOrder, elements) => {
        const category = document.querySelector('[data-category]');
        const categoryName = selectedLabel(category) || '';

        const typeField = document.querySelector('[data-type]');
        const typeLabel = selectedLabel(typeField) || '';

        const uf = document.querySelector('[data-uf]');
        const city = document.querySelector('[data-city]');
        const neighborhood = document.querySelector('[data-neighborhood]');

        const ufLabel = selectedLabel(uf) || 'Todos os Estados';
        const cityLabel = selectedLabel(city) || 'Todas as Cidades';
        const neighborhoodLabel = selectedLabel(neighborhood) || 'Todos os Bairros';

        const cityUfLabel = [cityLabel, ufLabel].join(' - ');

        const description = [neighborhoodLabel];

        description.push(cityUfLabel);

        let term;

        if (typeLabel) {
          term = categoryName ? `${typeLabel} (${categoryName})` : typeLabel;

          if (isPresent(search)) term = `${term}: ${search}`;
        } else if (categoryName) {
          term = categoryName;

          if (isPresent(search)) term = `${term}: ${search}`;
        } else if (search) {
          term = search;
        } else {
          term = document.querySelector('[data-title]').dataset.title;
        }

        document.querySelector('[data-search-term]').innerText = term;
        document.querySelector('[data-search-description]').innerText = description.join(', ');
      },

      paramsElements: [
        '[data-category]',
        '[data-city]',
        '[data-neighborhood]',
        '[data-type]',
        '[data-uf]',
        '[data-raking-sorter-field]',
      ],
    };
  }

  #addActiveClass(option) {
    option.addClass('switcher__option--active');
  }

  #cleanSwitcherOptions(sortOption, options) {
    for (var i = 0; i < options.length; i++) {
      var el = $(options[i]);

      if (el.data('sort') !== sortOption) {
        el.removeClass('switcher__option--active');
      }
    }
  }

  #activeSwitcherOption(switcherOption, sortOption) {
    var options = switcherOption.parent().parent().find('[data-switcher-option]');

    this.#cleanSwitcherOptions(sortOption, options);

    this.#addActiveClass(switcherOption);
  }
}
